class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchHiddenMobileButton = document.querySelector('#mobileHiddenSearchButton');
    this.isClosedManually = false;
    this.predictiveSearchResults.style.display = 'none'

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      if (this.input.value.trim() === '') {
        this.getSearchResults('christopher');
      }
    });
    if (this.searchHiddenMobileButton) {
      this.searchHiddenMobileButton.addEventListener('click', () => {            
        if (this.predictiveSearchResults.style.display === 'flex') {
          this.close();
          this.isClosedManually = true;
        } else {
          this.isClosedManually = false;
          if (this.input.value.trim() === '') {
            this.getSearchResults('christopher');
          }
        }
      });
    }
    
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    // if (searchTerm == '') {
    //   searchTerm = 'christopher'
    // }

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // fetch(`/search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&product&section_id=predictive-search`)
    fetch(`/search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'flex';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);